import { render, staticRenderFns } from "./updateTemplate.vue?vue&type=template&id=5ee32fbc&"
import script from "./updateTemplate.vue?vue&type=script&lang=ts&"
export * from "./updateTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports